/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const checkUsernameExists = /* GraphQL */ `
  query CheckUsernameExists($username: String!) {
    checkUsernameExists(username: $username)
  }
`;
export const getPersonalData = /* GraphQL */ `
  query GetPersonalData {
    getPersonalData {
      PK
      SK
      firstName
      lastName
      dateOfBirth
      nationOfBirth
      provinceOfBirth
      birthPlace
      nationality
      gender
      fiscalCode
      fiscalCodeConfirm
      country
      province
      city
      address
      houseNumber
      zipCode
      mobileNumberPrefix
      mobileNumber
      phoneNumberPrefix
      phoneNumber
      documentType
      number
      releaseDate
      expirationDate
      releasedBy
      nickname
      email
      securityQuestion
      secretAnswer
      presenterCode
      promoCode
      period
      depositLimit
      confirmDepositLimit
      adultYes
      termsAndConditionYes
      privacyTerms
      newsletterYes
      createdAt
      userStatus
    }
  }
`;
export const checkAccountState = /* GraphQL */ `
  query CheckAccountState {
    checkAccountState {
      PK
      SK
      accountState
      deposit
      bonus
      withdrawable
      valute
      createdAt
      lastDepositDate
      weekTotal
      monthTotal
      depositLimit
      depositLimitPeriod
      pickedUp
      expenses
      updatedAt
      winnings
    }
  }
`;
export const getMessages = /* GraphQL */ `
  query GetMessages(
    $limit: Int
    $filter: MessageFilterInput
    $nextToken: String
  ) {
    getMessages(limit: $limit, filter: $filter, nextToken: $nextToken) {
      items {
        PK
        SK
        messageCategory
        createdAt
        author
        messageSubject
        readed
      }
      nextToken
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($PK: String!, $SK: String!, $readed: String!) {
    getMessage(PK: $PK, SK: $SK, readed: $readed) {
      PK
      SK
      messageText
      messageCategory
      createdAt
      author
      messageSubject
    }
  }
`;
export const getMessagesStat = /* GraphQL */ `
  query GetMessagesStat {
    getMessagesStat {
      newMessages
      readedMessages
    }
  }
`;
export const getMovementsList = /* GraphQL */ `
  query GetMovementsList {
    getMovementsList {
      items {
        PK
        SK
        orderId
        createdAt
        valute
        gameSession
        provider_hook
        updatedAt
        amount
        provider
        username
        description
        provider_hook_event
        id
        status
        amountWinning
        sign
      }
      nextToken
    }
  }
`;
export const getPendingWithdrawal = /* GraphQL */ `
  query GetPendingWithdrawal {
    getPendingWithdrawal {
      items {
        PK
        SK
        orderId
        createdAt
        valute
        gameSession
        provider_hook
        updatedAt
        amount
        provider
        username
        description
        provider_hook_event
        id
        status
        amountWinning
        sign
      }
      nextToken
    }
  }
`;
export const getMovement = /* GraphQL */ `
  query GetMovement($PK: String!) {
    getMovement(PK: $PK) {
      PK
      SK
      orderId
      createdAt
      valute
      gameSession
      provider_hook
      updatedAt
      amount
      provider
      username
      description
      provider_hook_event
      id
      status
      amountWinning
      sign
    }
  }
`;
export const getLatestWinners = /* GraphQL */ `
  query GetLatestWinners($limit: Int, $dal: Int!, $al: Int!) {
    getLatestWinners(limit: $limit, dal: $dal, al: $al) {
      username
      amount
      amountWinning
      valute
    }
  }
`;
export const getKioskData = /* GraphQL */ `
  query GetKioskData {
    getKioskData {
      PK
      SK
      name
      id
      cash {
        PK
        SK
        address
        city
        confirmDepositLimit
        country
        createdAt
        depositLimit
        firstName
        houseNumber
        lastName
        nickname
        period
        province
        updatedAt
        userStatus
        zipCode
        account {
          PK
          SK
          accountState
          deposit
          bonus
          withdrawable
          valute
          createdAt
          lastDepositDate
          weekTotal
          monthTotal
          depositLimit
          depositLimitPeriod
          pickedUp
          expenses
          updatedAt
          winnings
        }
      }
      station
      backgroundImg
    }
  }
`;
export const getGameCompanyList = /* GraphQL */ `
  query GetGameCompanyList {
    getGameCompanyList {
      PK
      SK
      id
      name
      games {
        PK
        SK
        id
        name
        category
        subcategory
        gamedata
        showLabel
        apiOperator
        urlEndPoint
        vendor
        updatedAt
        gameLaunchUrl
      }
      sections
      apiOperator
      urlEndPoint
    }
  }
`;
export const getGameCompany = /* GraphQL */ `
  query GetGameCompany($name: String!) {
    getGameCompany(name: $name) {
      PK
      SK
      id
      name
      games {
        PK
        SK
        id
        name
        category
        subcategory
        gamedata
        showLabel
        apiOperator
        urlEndPoint
        vendor
        updatedAt
        gameLaunchUrl
      }
      sections
      apiOperator
      urlEndPoint
    }
  }
`;
export const getGamesListByCompany = /* GraphQL */ `
  query GetGamesListByCompany(
    $gameCompany: String!
    $category: String
    $limit: Int
    $nextToken: String
  ) {
    getGamesListByCompany(
      gameCompany: $gameCompany
      category: $category
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        SK
        id
        name
        category
        subcategory
        gamedata
        showLabel
        apiOperator
        urlEndPoint
        vendor
        updatedAt
        gameLaunchUrl
      }
      nextToken
    }
  }
`;
export const getGamesList = /* GraphQL */ `
  query GetGamesList(
    $category: String!
    $subcategory: String
    $vendor: String
    $limit: Int
    $nextToken: String
  ) {
    getGamesList(
      category: $category
      subcategory: $subcategory
      vendor: $vendor
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        SK
        id
        name
        category
        subcategory
        gamedata
        showLabel
        apiOperator
        urlEndPoint
        vendor
        updatedAt
        gameLaunchUrl
      }
      nextToken
    }
  }
`;
export const getGameCategoryStat = /* GraphQL */ `
  query GetGameCategoryStat($category: String!) {
    getGameCategoryStat(category: $category) {
      PK
      SK
      number
      subs
      vendors
      updatedAt
    }
  }
`;
export const getGameById = /* GraphQL */ `
  query GetGameById($gameId: String) {
    getGameById(gameId: $gameId) {
      PK
      SK
      id
      name
      category
      subcategory
      gamedata
      showLabel
      apiOperator
      urlEndPoint
      vendor
      updatedAt
      gameLaunchUrl
    }
  }
`;
export const getGame = /* GraphQL */ `
  query GetGame($PK: String!, $SK: String!) {
    getGame(PK: $PK, SK: $SK) {
      PK
      SK
      id
      name
      category
      subcategory
      gamedata
      showLabel
      apiOperator
      urlEndPoint
      vendor
      updatedAt
      gameLaunchUrl
    }
  }
`;
export const getSessionData = /* GraphQL */ `
  query GetSessionData($sessionId: String) {
    getSessionData(sessionId: $sessionId) {
      PK
      SK
      lang
      currency
      username
      live
      gameId
      demo
      createdAt
      updatedAt
      liveUpdatedAt
      level
      buyIn
      expenses
      winnings
      balance
      game {
        PK
        SK
        id
        name
        category
        subcategory
        gamedata
        showLabel
        apiOperator
        urlEndPoint
        vendor
        updatedAt
        gameLaunchUrl
      }
    }
  }
`;
export const checkLiveSession = /* GraphQL */ `
  query CheckLiveSession($provider: String) {
    checkLiveSession(provider: $provider) {
      PK
      SK
      lang
      currency
      username
      live
      gameId
      demo
      createdAt
      updatedAt
      liveUpdatedAt
      level
      buyIn
      expenses
      winnings
      balance
      game {
        PK
        SK
        id
        name
        category
        subcategory
        gamedata
        showLabel
        apiOperator
        urlEndPoint
        vendor
        updatedAt
        gameLaunchUrl
      }
    }
  }
`;
export const getPlayerBookmark = /* GraphQL */ `
  query GetPlayerBookmark($section: String!) {
    getPlayerBookmark(section: $section) {
      PK
      SK
      gameIds
    }
  }
`;
export const getConfig = /* GraphQL */ `
  query GetConfig {
    getConfig
  }
`;
export const getCashMovementsList = /* GraphQL */ `
  query GetCashMovementsList($limit: Int, $nextToken: String) {
    getCashMovementsList(limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        orderId
        createdAt
        valute
        gameSession
        provider_hook
        updatedAt
        amount
        provider
        username
        description
        provider_hook_event
        id
        paymentStatus
        status
        amountWinning
        contract
        note
        desk {
          PK
          SK
          name
          id
          station
          backgroundImg
          screenLocked
        }
        sign
      }
      nextToken
    }
  }
`;
export const getBettingsList = /* GraphQL */ `
  query GetBettingsList {
    getBettingsList {
      items {
        PK
        SK
        orderId
        createdAt
        valute
        gameSession
        provider_hook
        updatedAt
        amount
        provider
        username
        description
        provider_hook_event
        id
        paymentStatus
        status
        amountWinning
        contract
        note
        desk {
          PK
          SK
          name
          id
          station
          backgroundImg
          screenLocked
        }
        sign
      }
      nextToken
    }
  }
`;
export const getContract = /* GraphQL */ `
  query GetContract($contractnumber: String!) {
    getContract(contractnumber: $contractnumber) {
      PK
      SK
      createdAt
    }
  }
`;
